<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-col cols="12" sm="12" md="12">
          <v-row dense class="mx-5">
            <v-row dense class="justify-start">
              <v-switch
                v-model="switch1"
                :label="
                  $t(
                    this.pay_settings.app_pay == 1
                      ? 'Payment.on'
                      : 'Payment.stop'
                  )
                "
                @change="change()"
              ></v-switch>
            </v-row>
          </v-row>
        </v-col>
        <v-row class="mx-2 my-1">
          <!-- 支付宝 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                <span>
                  {{ $t("Payment.alipay") }}
                </span>
                <v-chip
                  small
                  label
                  :color="
                    pay_settings.alipay_h5_enable == 1 ? 'primary' : 'gray'
                  "
                  class="mx-1"
                >
                  {{
                    pay_settings.alipay_h5_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>仅提供移动应用内支付功能。</span>
                <br />
                <span
                  >需开通企业支付宝账号，仅支持以企业对公账户作为收款账户。</span
                >
                <br />
                <span>交易手续费由支付宝公司向收款方收取。</span>
                <br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/alipay165x58.png')"
                    max-height="48"
                    max-width="137"
                  />
                  <v-spacer />
                  <v-btn
                    :href="'/#/payment/alipay-h5'"
                    color="info"
                    align-self="center"
                    >{{ $t("Payment.setting") }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 银联在线ChinaPay -->
          <v-col cols="12" sm="12" md="6" v-show="false">
            <v-card>
              <v-card-title>
                {{ $t("Payment.china_pay") }}
                <v-chip
                  small
                  label
                  :color="
                    pay_settings.chinapay_h5_enable == 1 ? 'primary' : 'gray'
                  "
                  class="mx-1"
                >
                  {{
                    pay_settings.chinapay_h5_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供移动应用和移动网页内支付功能。</span><br />
                <span>需开通银联在线商户账号。</span><br />
                <span>交易手续费由银联在线向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/chinapay150x48.gif')"
                    max-height="48"
                    max-width="150"
                  />
                  <v-spacer />
                  <v-btn :href="'/#/payment/chinapay-h5'" color="info">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 微信官方小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.wechat") }}
                <v-chip
                  small
                  label
                  :color="
                    pay_settings.wechat_mini_enable == 1 ? 'primary' : 'gray'
                  "
                  class="mx-1"
                >
                  {{
                    pay_settings.wechat_mini_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通微信支付。</span><br />
                <span>交易手续费由微信官方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/wechatpay215x58.png')"
                    max-height="48"
                    max-width="178"
                  />
                  <v-spacer />
                  <v-btn :href="'/#/payment/wechat-pay'" color="info">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 微信官方V3小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.wechatV3") }}
                <v-chip
                  small
                  label
                  :color="
                    pay_settings.wechat_v3_enable == 1 ? 'primary' : 'gray'
                  "
                  class="mx-1"
                >
                  {{
                    pay_settings.wechat_v3_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信V3小程序内支付功能。</span><br />
                <span>需开通微信支付。</span><br />
                <span>交易手续费由微信官方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/wechatpay215x58.png')"
                    max-height="48"
                    max-width="178"
                  />
                  <v-spacer />
                  <v-btn :href="'/#/payment/wechat-v3-pay'" color="info">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 微信官方B2B小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.wechatB2B") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.wechat_b2b_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.wechat_b2b_enable == 1
                    ? $t("Payment.start")
                    : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信B2B小程序内支付功能。</span><br />
                <span>需开通微信支付。</span><br />
                <span>交易手续费由微信官方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/wechatpay215x58.png')"
                    max-height="48"
                    max-width="178"
                  />
                  <v-spacer />
                  <v-btn :href="'/#/payment/wechat-b2b-pay'" color="info">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 联富通微信小程序支付 -->
          <v-col cols="12" sm="12" md="6" v-show="false">
            <v-card>
              <v-card-title>
                {{ $t("Payment.lftpay_enable") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.lftpay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.lftpay_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通联富通商户账号。</span><br />
                <span>交易手续费由联富通向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/lftpay178x70.png')"
                    max-height="48"
                    max-width="123"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/lft-pay'">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 新大陆微信小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.newlandpay") }}
                <v-chip
                  small
                  label
                  :color="
                    pay_settings.newlandpay_enable == 1 ? 'primary' : 'gray'
                  "
                  class="mx-1"
                >
                  {{
                    pay_settings.newlandpay_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通新大陆商户账号。</span><br />
                <span>交易手续费由新大陆向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/newland150x56.jpg')"
                    max-height="48"
                    max-width="123"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/newland-pay'">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 易生小程序支付 -->
          <v-col cols="12" sm="12" md="6" v-show="false">
            <v-card>
              <v-card-title>
                {{ $t("Payment.easypay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.easypay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.easypay_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通易生商户账号。</span><br />
                <span>交易手续费由易生向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/easypay268x87.jpg')"
                    max-height="48"
                    max-width="148"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/easy-pay'">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 汇付小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.hfpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.hfpay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.hfpay_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通汇付商户账号。</span><br />
                <span>交易手续费由汇付向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/hfpay273x86.jpeg')"
                    max-height="48"
                    max-width="153"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/hf-pay'">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 网商小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.wspay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.wspay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.wspay_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通网商商户账号。</span><br />
                <span>交易手续费由网商向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <!-- <v-img
                    :src="require('@/assets/payment/hfpay273x86.jpeg')"
                    max-height="48"
                    max-width="153"
                  /> -->
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/ws-pay'">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 汇付斗拱小程序支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.hfdgpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.hfdgpay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.hfdgpay_enable == 1
                      ? $t("Payment.start")
                      : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通汇付斗拱商户账号。</span><br />
                <span>交易手续费由汇付斗拱向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/hfdg.jpg')"
                    max-height="48"
                    max-width="153"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/hfdg-pay'">{{
                    $t("Payment.setting")
                  }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 随行付支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.sxfpay") }}
                <v-chip
                        small
                        label
                        :color="pay_settings.sxfpay_enable == 1 ? 'primary' : 'gray'"
                        class="mx-1"
                >
                  {{
                  pay_settings.sxfpay_enable == 1
                  ? $t("Payment.start")
                  : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通随行付商户账号。</span><br />
                <span>交易手续费由随行付向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                          :src="require('@/assets/payment/sxf.jpg')"
                          max-height="48"
                          max-width="120"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/sxf-pay'">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 建行扫码支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.ccbpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.ccb_scan_pay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                {{
                  pay_settings.ccb_scan_pay_enable == 1
                  ? $t("Payment.start")
                  : $t("Payment.off")
                }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通建行扫码支付商户账号。</span><br />
                <span>交易手续费由随行付向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/ccb.jpg')"
                    max-height="48"
                    max-width="120"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/ccb-pay'">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 拉卡拉支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.lklpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.lakalapay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.lakalapay_enable == 1
                    ? $t("Payment.start")
                    : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通拉卡拉支付商户账号。</span><br />
                <span>交易手续费由拉卡拉向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/lkl.jpg')"
                    max-height="48"
                    max-width="120"
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/lkl-pay'">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
           <!-- 扫呗支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.lcswpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.lcswpay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.lcswpay_enable == 1
                    ? $t("Payment.start")
                    : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通扫呗支付商户账号。</span><br />
                <span>交易手续费由扫呗向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/saobei.png')"
                    max-height="48"
                    max-width="120"
                    contain
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/lcsw-pay'">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 扫呗cbk支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.lcswcbkpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.lcswpay_cbk_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.lcswpay_cbk_enable == 1
                    ? $t("Payment.start")
                    : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信小程序内支付功能。</span><br />
                <span>需开通扫呗支付商户账号。</span><br />
                <span>交易手续费由扫呗向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <v-img
                    :src="require('@/assets/payment/saobei.png')"
                    max-height="48"
                    max-width="120"
                    contain
                  />
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/lcsw-cbk-pay'">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- 众付通支付 -->
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title>
                {{ $t("Payment.crowdpay") }}
                <v-chip
                  small
                  label
                  :color="pay_settings.crowdpay_enable == 1 ? 'primary' : 'gray'"
                  class="mx-1"
                >
                  {{
                    pay_settings.crowdpay_enable == 1
                    ? $t("Payment.start")
                    : $t("Payment.off")
                  }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <span>可提供微信公众号支付功能。</span><br />
                <span>需开通众付通支付商户账号。</span><br />
                <span>交易手续费由众付通平台向收款方收取。</span><br />
                <div class="mt-3 mb-1 d-flex align-center">
                  <!-- <v-img
                    :src="require('@/assets/payment/crowdpay.png')"
                    max-height="48"
                    max-width="120"
                    contain
                  /> -->
                  <v-spacer />
                  <v-btn color="info" :href="'/#/payment/crowd-pay'">{{
                    $t("Payment.setting")
                    }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import Payment from "@/api/payment";

export default {
  data: () => ({
    switch1: true,
    pay_settings: {},
  }),

  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
  },

  mounted() {
    this.getPayMentFromAPI();
    // console.log(this);
  },

  methods: {
    getPayMentFromAPI() {
      Payment.fetch().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.pay_settings = response.data.pay_settings;
            if (response.data.pay_settings.app_pay == 1) {
              this.switch1 = true;
            } else {
              this.switch1 = false;
            }
          }
        }.bind(this)
      );
    },
    change() {
      this.$store.dispatch("fullscreenLoading");
      Payment.editAppPay(this.switch1 == true ? 1 : 0)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getPayMentFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },
};
</script>
